export const TERMS_AND_CONDITION_CONSTANT = [
  {
    title: "Umum",
    description: `
      <p>
        PT Abisatya Pialang Asuransi (selanjutnya disebut &ldquo;<strong>kami</strong>&rdquo;, &ldquo;<strong>Kami</strong>&rdquo;, &ldquo;<strong>kita</strong>&rdquo;, &ldquo;<strong>Lifepal</strong>&rdquo;) adalah perusahaan pialang asuransi yang berizin dan diawasi oleh Otoritas Jasa Keuangan (&ldquo;OJK&rdquo;) sesuai dengan Surat Nomor KEP-018/KMK.17/1992 dan Surat Persetujuan Penyelenggaraan Layanan Pialang Asuransi Digital (LPAD) dengan Nomor: S-463/PD.113/2025. Kami juga merupakan pemilik merek "Lifepal", yang memberikan layanan kepada pengguna perwakilan pengguna yang sah, dan setiap entitas yang mungkin Anda wakili sehubungan dengan penggunaan Situs Web Kami lifepal (selanjutnya disebut &ldquo;<strong>Anda</strong>&rdquo;, &ldquo;<strong>anda</strong>&rdquo;, &ldquo;<strong>Milik Anda</strong>&rdquo;, &ldquo;<strong>Pengguna</strong>&rdquo;), di mana kami menawarkan layanan online independen untuk membandingkan layanan asuransi yang disediakan oleh mitra asuransi kami (&ldquo;<strong>Layanan</strong>&rdquo;).
      </p>

      <p>
        Dengan mengunjungi Lifepal.co.id dan saluran media sosial kami lainnya (&ldquo;<strong>Situs Web</strong>&rdquo;), kami menganggap bahwa Anda menyetujui Syarat dan Ketentuan ini serta <strong>Kebijakan Privasi</strong> dan Anda menyatakan bahwa Anda setidaknya berusia 18 tahun atau lebih atau setidaknya usia mayoritas di mana Anda tinggal dianggap dewasa. Anda juga menjamin bahwa Anda adalah orang yang berwenang untuk menggunakan Layanan kami. 
      </p>

      <p>
        Silakan baca Syarat dan Ketentuan dan Kebijakan Privasi secara menyeluruh. Mungkin ada syarat dan ketentuan atau persyaratan tambahan di Situs Web kami, yang mungkin muncul saat Anda mengunjungi halaman Situs Web tersebut. Anda dianggap menyetujui seluruh Syarat dan Ketentuan yang tercantum Situs Web ini dan Layanan yang kami berikan saat Anda mengakses, menggunakan, serta meninjau Layanan yang kami berikan pada Situs Web ini dan Layanan lainnya yang tersedia. Jika Anda tidak setuju untuk mematuhi aturan ini, Anda tidak diizinkan untuk mengakses atau menggunakan konten atau Layanan yang disediakan oleh Lifepal.
      </p>

      <p>
        Sebelum menggunakan Layanan kami, Anda perlu membaca dan memahami semua informasi Layanan, termasuk manfaat, biaya, premi, dan pengecualian terkait produk asuransi. Anda juga perlu melengkapi semua informasi yang diberikan dalam aplikasi asuransi Anda secara akurat dan jujur, yang mencerminkan keadaan Anda yang sebenarnya. Harap baca dan periksa dengan seksama semua informasi di Situs Web sebelum Anda membayar. 
      </p> 
    `,
  },
  {
    title: "Penggunaan Layanan",
    description: `
      <p>
        Kami akan menyediakan Layanan sebagai berikut: 
      </p>

      <ol>
        <li>
        Penyediaan informasi, sumber daya, dan alat untuk membantu Anda dalam belajar, memahami, membandingkan, dan membuat keputusan berdasarkan informasi tentang pilihan produk asuransi Anda dan perusahaan asuransi yang menerbitkan produk tersebut;
        </li>

        <li>
          Pemberian konsultasi, saran, dan rekomendasi produk dan portofolio asuransi; 
        </li>

        <li>
          Evaluasi kebutuhan asuransi Anda; 
        </li>

        <li>
          Penyediaan berbagai produk asuransi kepada Anda; 
        </li>

        <li>
          Bantuan aplikasi asuransi atau pembayaran produk asuransi; dan/atau 
        </li>

        <li>
          Bantuan dalam penyelesaian klaim asuransi Anda; melalui berbagai cara dan metode termasuk telepon, panggilan video, email, Situs Web, atau aplikasi. 
        </li>
      </ol>

      <p>
        Perbandingan ini disediakan secara gratis. Harap diingat bahwa kami adalah perusahaan pialang asuransi, bukan penyedia asuransi. Oleh karena itu, kami tidak menanggung klaim Anda tetapi untuk membantu klaim Anda dengan penyedia asuransi.
      </p>

      <p>
        Anda setuju bahwa dengan memberikan informasi termasuk namun tidak terbatas pada kontak Anda dalam bentuk nomor telepon, Anda bersedia dihubungi oleh Lifepal melalui telepon, SMS, email atau aplikasi chat. Layanan kami tidak memberikan saran atau rekomendasi apa pun sehubungan dengan masalah pribadi, masalah keuangan, investasi, atau saran lainnya, sehingga Anda harus membuat keputusan sendiri sebelum mengikuti informasi apa pun di Situs Web atau tautan lain di Situs Web kami.
      </p>

      <p>
        Kami berhak untuk menolak permintaan Anda untuk menggunakan Layanan kami, termasuk namun tidak terbatas pada, jika Anda tidak memenuhi persyaratan yang ditentukan oleh penyedia asuransi atau jika Anda memberikan informasi yang salah atau menyesatkan.
      </p>

      <p>
        Kami berhak untuk mengubah informasi apa pun di Situs Web atau menangguhkan pengoperasian Situs Web untuk perbaikan dan pemeliharaan kapan saja, tanpa pemberitahuan sebelumnya kepada Anda sesuai dengan pertimbangan Kami. Silakan periksa Syarat dan Ketentuan ini dari waktu ke waktu. 
      </p>

      <p>
        Dengan menggunakan Situs Web dan/atau Layanan kami, Anda mengakui dan menyetujui bahwa Anda telah memberikan kuasa dan mengizinkan kami untuk menggunakan, memberikan informasi dan keterangan mengenai Anda yang kami peroleh atau simpan kepada pihak-pihak lain di dalam maupun di luar negeri yang memiliki hubungan kerja sama dengan kami termasuk namun tidak terbatas sehubungan dengan pengajuan asuransi Anda, pembayaran klaim, pelayanan dan pemasaran produk lain kepada Anda; dan/atau memastikan kebenaran informasi/data Anda, dan/atau menawarkan dukungan dan informasi atas produk asuransi; dan/atau membantu Anda menemukan produk asuransi yang sesuai dengan kebutuhan Anda; dan/atau merespon pertanyaan, keluhan dan klaim Anda; dan/atau memenuhi ketentuan peraturan yang berlaku baik di Indonesia atau di negara lain sesuai dengan ketentuan hukum yang berlaku dan Layanan yang kami berikan.
      </p>
    `,
  },
  {
    title: "Kekayaan Intelektual dan Konten Situs Web",
    description: `
      <p>
        Semua informasi dan konten di Situs Web, dan dokumen yang dapat diunduh termasuk namun tidak terbatas pada merek dagang, merek layanan, logo, gambar, nama dagang, desain dan format konten dan komponen lainnya (Informasi) adalah milik Lifepal, kecuali dinyatakan lain. Kami dan / atau pihak ketiga dengan izin kami adalah orang-orang yang memiliki hak untuk menggunakan hak cipta, merek dagang, atau merek layanan yang diberikan dalam Informasi di Situs Web kami.
      </p>

      <p>
        Tidak seorang pun boleh mereproduksi, menyalin, mengadaptasi, menerbitkan, menjual, mendistribusikan, atau mengeksploitasi Informasi, baik sebagian atau seluruhnya, untuk tujuan apa pun selain membuat pertimbangannya dalam membeli Layanan dengan kami, tanpa persetujuan tertulis sebelumnya dari kami. 
      </p>

      <p>
        Untuk kenyamanan Anda dalam menggunakan Situs Web kami, mungkin ada tautan ke Situs Web yang dimiliki dan dikelola oleh pihak ketiga. Kami tidak menjamin keakuratan, kelengkapan, atau keamanan informasi di situs web pihak ketiga tersebut. 
      </p>

      <p>
        Jika Anda menempatkan rekomendasi dan / atau komentar Anda di Situs Web kami, kami menganggap bahwa Anda telah memberi kami hak mutlak untuk menggunakan rekomendasi dan / atau komentar ini tanpa biaya atau persetujuan Anda sebelumnya. Selain itu, kami menganggap bahwa Anda menjamin dengan kami bahwa Anda tidak akan memberikan rekomendasi dan / atau komentar dengan cara yang melanggar hak kami atau pihak ketiga.
      </p>
    `,
  },
  {
    title: "Keakuratan Informasi Pihak Ketiga dan Tautan Lainnya",
    description: `
      <p>
        Sejauh diizinkan oleh hukum yang berlaku, kami mengambil langkah-langkah yang wajar dan perlu untuk memastikan bahwa dengan menggunakan Situs Web kami, Anda memperoleh Informasi yang akurat, lengkap, dan terbaru, dalam kondisi situs web normal - untuk pengalaman terbaik Anda. Namun, dalam keadaan apa pun, kami tidak dapat menjamin bahwa informasi yang kami berikan di Situs Web ini benar-benar akurat, lengkap, atau terkini. Materi di Situs Web ini disediakan hanya untuk informasi umum dan tidak boleh diandalkan atau digunakan sebagai satu-satunya dasar untuk membuat keputusan penting tanpa berkonsultasi dengan sumber lain dari informasi yang lebih akurat, lebih lengkap, atau lebih tepat waktu.
      </p>

      <p>
        Setiap ketergantungan pada materi di Situs Web ini adalah risiko Anda sendiri. Kami menyarankan Anda agar membaca serta memahami isi dari syarat dan ketentuan yang berlaku di tautan milik Pihak Ketiga tersebut.
      </p>
    `,
  },
  {
    title: "Penggunaan Situs Web dan Pembelian Layanan",
    description: `
      <p>
        Situs Web dan Layanan kami disediakan untuk penggunaan dan pembelian oleh warga negara Indonesia dan mereka yang diizinkan untuk tinggal secara sah di Indonesia. Situs Web dan Layanan kami mungkin tidak diakses atau dibeli secara legal di beberapa negara. Oleh karena itu, dengan mengunjungi Situs Web Kami dan membeli Layanan kami, setiap orang dengan kewarganegaraan selain Indonesia akan bertanggung jawab atas legalitas kewarganegaraannya atau negara lain yang tunduk pada orang tersebut sendiri. Untuk semua transaksi, harga dan pembayaran hanya dalam Rupiah Indonesia. 
      </p>

      <p> Anda menyatakan dan menjamin bahwa Anda:</p>
      
      <ol style="list-style-type: lower-alpha;">
        <li>
          Tidak akan menggunakan Situs Web ini untuk tujuan lain selain bertindak sebagai pelanggan; 
        </li>

        <li>
          Tidak akan menyebabkan kerusakan pada Situs Web ini; 
        </li>

        <li>
          Tidak boleh menggunakan Layanan dan Layanan kami untuk tujuan ilegal atau tidak sah. Jika Anda ditemukan telah terlibat dalam penggunaan ilegal atau penyalahgunaan Situs Web Kami, Lifepal akan menangguhkan akun Anda atau penggunaan yang berlaku; 
        </li>

        <li>
          Jangan mereproduksi, mendistribusikan, memodifikasi, menggandakan, menyalin, mentransfer, menjual, menjual kembali, menampilkan, menerbitkan, menggunakan kembali, atau mengeksploitasi bagian mana pun dari Layanan, penggunaan Layanan, atau akses ke Layanan tanpa izin tertulis dari Lifepal; 
        </li>

        <li>
          Tidak menggunakan Situs Web atau platform Lifepal lainnya untuk tujuan periklanan, pemasaran, dan komersial; 
        </li>

        <li>
          Tidak memanipulasi atau memalsukan informasi dengan maksud untuk menyamarkan asal usul pernyataan yang Anda berikan; 
        </li>

        <li>
          Jangan mengirim atau menyimpan materi apa pun yang mengandung virus perangkat lunak, worm, trojan horse, atau kode komputer berbahaya lainnya ke Situs Web; 
        </li>

        <li>
          Tidak mengirim atau menyimpan materi yang dapat melanggar kekayaan intelektual atau hak-hak lain dari entitas atau individu, termasuk namun tidak terbatas pada hak cipta, paten, merek dagang, rahasia dagang, atau informasi atau publikasi rahasia; 
        </li>

        <li>
          Tidak mengirim spam atau pesan lain yang tidak diminta atau menyebabkan gangguan, gangguan, atau ketidaknyamanan; 
        </li>
      </ol>
      
      <p>
        Pelanggaran terhadap salah satu Syarat dan Ketentuan sebagaimana ditentukan dalam kebijaksanaan Lifepal akan mengakibatkan penghentian segera Layanan Anda.
      </p>
    `,
  },
  {
    title: "Syarat dan Ketentuan Layanan",
    description: `
      <p>
        Konten di Situs Web Kami tidak akan dianggap sebagai tawaran untuk menjual Layanan kami. Hanya permintaan Anda untuk membeli Layanan kami yang akan dianggap sebagai penawaran, yang dapat kami terima atau tolak dengan mempertimbangkan Syarat dan Ketentuan kami.
      </p>

      <p>
        Semua permintaan sehubungan dengan Layanan di Situs Web Kami harus sesuai dengan persyaratan yang ditentukan oleh pemilik produk atau pihak ketiga yang bekerjasama dengan kami yang relevan seperti mitra atau penyedia Asuransi. Silakan baca detail tambahan dalam polis Anda. 
      </p>

      <p>
        Dengan memberikan informasi atau dokumen kepada kami, Anda dianggap setuju dengan Kebijakan Privasi kami. Anda juga menjamin bahwa informasi dan dokumen tersebut akurat, lengkap, terkini, dan aman. Jika ada perubahan, Anda memiliki kewajiban untuk segera memberi tahu kami tentang perubahan tersebut. Jika kami mengetahui bahwa informasi tentang Anda atau informasi lain (termasuk pemegang manfaat Anda, kendaraan yang diasuransikan, anggota keluarga yang diasuransikan atau tertanggung lainnya) bertentangan dengan informasi yang diberikan kepada kami, kami berhak untuk membatalkan polis Anda dan mengklaim kerusakan (jika ada), atau menggunakan syarat dan ketentuan baru kami dan harga baru sesuai pertimbangan kami sendiri. Terlepas dari kenyataan bahwa temuan tersebut terjadi setelah kami menerima penawaran Anda dan/atau pembayaran Anda. 
      </p>

      <p>
        Setiap produk asuransi yang disediakan oleh mitra atau penyedia asuransi pada Situs Web Kami adalah pihak yang memiliki kerjasama dan perikatan yang sah dengan kami dan oleh karenanya Anda mengakui bahwa: 
      </p>

      <ol style="list-style-type: lower-alpha;">
        <li>
          Setiap pemesanan dan pembelian yang Anda lakukan melalui Situs Web Kami merupakan hubungan hukum yang sah dan mengikat antara Anda dan mitra/penyedia asuransi kami. Kami selaku pialang asuransi hanya bertugas sebagai fasilitator antara Anda dan mitra/penyedia asuransi.
        </li>

        <li>
          Setiap dan seluruh data dan dan informasi yang tercantum dalam Situs Web terkait dengan produk asuransi merupakan data dan informasi yang kami terima dari mitra/penyedia asuransi dan dipublikasikan oleh kami dengan itikad baik dan sesuai dengan data terbaru yang kami terima.  
        </li>

        <li>
          Setiap dan seluruh data dan informasi yang kami cantumkan tidak dapat dijamin sebagai data yang disajikan secara lengkap, akurat dan benar serta terbebas dari kesalahan dan Anda mengetahui serta sepakat bahwa kami tidak memiliki kendali atas informasi yang diberikan oleh mitra atau penyedia asuransi untuk setiap produk asuransi yang tercantum pada Situs Web kami. 
        </li>

        <li>
          Kami membuat rekomendasi produk berdasarkan informasi yang Anda berikan. Keputusan untuk memilih produk asuransi adalah kebebasan Anda sepenuhnya dan Anda bertanggung jawab untuk pilihan akhir dari produk asuransi. 
        </li>

        <li>
          Sejauh yang diizinkan oleh hukum, Kami memiliki hak untuk menolak penerimaan pemesanan (atau dalam kasus tertentu membatalkan konfirmasi pemesanan) atas produk asuransi berdasarkan kebijakan kami yang berlaku, tanpa perlu memberikan alasan penolakan, penampikan, atau pembatalan. 
        </li>

        <li>
          Anda tidak dapat menyerahkan atau mengalihkan hak atau kewajiban Anda terkait produk asuransi yang sudah Anda terima manfaatnya menurut Syarat dan Ketentuan ini, kecuali ditentukan lain atau tanpa persetujuan tertulis Kami sebelumnya. 
        </li>
      </ol>

      <p>
        Anda setuju dan memahami bahwa mitra/penyedia asuransi pada Situs Web Kami berhak untuk menolak dan membatalkan permohonan asuransi Anda dan/atau mengakhiri polis apabila: 
      </p>

      <ol style="list-style-type: lower-alpha;">
        <li>
          Anda tidak memenuhi persyaratan uji tuntas yang berlaku;
        </li>

        <li>
          Anda ditemukan telah memberikan informasi yang dipertanyakan atau salah; dan 
        </li>

        <li>
          Anda memiliki sumber dana transaksi yang diketahui atau diduga berasal dari kegiatan kriminal.
        </li>
      </ol>

      <p>
        Kami tidak akan bertanggung jawab atas kerugian dan / atau kerusakan yang timbul dari kegagalan Anda untuk mematuhi kewajiban Anda dalam paragraf sebelumnya. Ini termasuk tetapi tidak terbatas pada, Anda tidak menerima informasi atau dokumen sebagai akibat dari kegagalan Anda untuk memberi tahu perubahan pada saluran kontak atau saluran pengiriman dokumen Anda, kecuali untuk kasus di mana ini disebabkan oleh kesalahan kami semata-mata. 
      </p>
    `,
  },
  {
    title: "Pembayaran",
    description: `
      <p>
        Sebelum memberi Anda instruksi untuk pembayaran, Anda mengonfirmasi bahwa Anda telah menerima, membaca, dan menerima informasi detail yang diperlukan untuk menerbitkan kebijakan Anda. Anda harus melakukan pembayaran biaya apa pun pada tanggal jatuh tempo dan sesuai dengan persyaratan yang ditentukan pada halaman informasi pembayaran di Situs Web Kami. Kami berhak untuk segera membatalkan polis Anda tanpa pemberitahuan sebelumnya jika Anda gagal melakukannya. Pengembalian dana harus sesuai dengan syarat dan ketentuan polis Anda dan mengikuti ketentuan bank atau penyedia jasa keuangan dari metode pembayaran yang digunakan.
      </p>

      <p>
        Kami bekerjasama dengan pihak ketiga dalam menyediakan berbagai metode pembayaran di dalam Situs Web ini. Untuk itu, syarat dan ketentuan masing-masing metode pembayaran tunduk pada masing-masing penyedia metode pembayaran. Apabila pembayaran premi dilakukan di luar saluran atau metode yang ditetapkan dalam Aplikasi/Web, atau dibayarkan langsung ke perusahaan asuransi melalui saluran terpisah, segala risiko dan konsekuensi atas pembayaran tersebut termasuk kemungkinan penolakan klaim karena premi tidak diterima oleh perusahaan asuransi maka hal tersebut menjadi tanggung jawab Anda dan/atau pelanggan. 
      </p>

      <p>
        Kami tidak menganjurkan Anda untuk melakukan pembayaran dari metode yang sudah kami sarankan, melakukan pembayaran ke agen tertentu, atau pihak ketiga atas produk asuransi yang Anda pilih dari Situs Web Kami. Setiap perubahan, pembatalan dan pengembalian dana serta hal-hal lainnya terkait pembayaran, silahkan mengacu pada polis Anda. 
      </p>

      <p>
        Anda dianjurkan untuk menghubungi kami untuk berkonsultasi baik melalui email maupun telepon jika Anda ragu terhadap sebuah Produk atau ketentuan dari Produk tersebut. 
      </p>
    `,
  },
  {
    title: "Pembayaran Angsuran",
    description: `
      <p>
        Situs Web Kami memberi Anda premi terjangkau yang dapat Anda bayarkan setiap bulan. Metode ini hanya tersedia untuk pembayaran dengan kartu kredit, transfer bank atau virtual account. Dengan memilih paket ini, Anda setuju dan menerima bahwa jika Anda gagal membayar cicilan apa pun, Anda melanggar syarat dan ketentuan pembayaran kami. Akibatnya, Situs Web Kami akan menganggap bahwa Anda telah menginstruksikan kami untuk membatalkan kebijakan Anda. Kami akan meminta Penyedia Asuransi untuk melanjutkan pembatalan polis Anda. Kami akan berusaha memberi tahu Anda melalui email, SMS, WhatsApp, dan telepon. Tanpa pembayaran dari Anda, polis Anda akan kedaluwarsa 30 hari setelah pembayaran Anda yang terlewat. 
      </p>

      <p>
        Jika Anda menggunakan kartu kredit, Anda memahami bahwa konten Anda (tidak termasuk informasi kartu kredit), dapat ditransfer tidak terenkripsi dan melibatkan (a) transmisi melalui berbagai jaringan; dan (b) perubahan untuk memenuhi dan menyesuaikan dengan persyaratan teknis jaringan atau peralatan. Informasi Kartu Kredit selalu dienkripsi selama transfer melalui jaringan.
      </p>
    `,
  },
  {
    title: "Keamanan dan Kerahasiaan Kegiatan",
    description: `
      <p>
        Lifepal sangat peduli dengan keamanan dan kenyamanan pelanggan saat melakukan aktivitas di Situs Web. Oleh karena itu, kami memiliki sistem keamanan untuk memberikan jaminan kepada pengguna bahwa aktivitas dan informasi Anda aman.
      </p>

      <p>
        Saat Anda menggunakan komputer umum, pastikan Anda telah keluar/keluar setelah menyelesaikan aktivitas. Pastikan bahwa user ID dan password/PIN akun Anda tidak diketahui siapapun, untuk menghindari penyalahgunaan oleh pihak lain. 
      </p>
    `
  },
  {
    title: "Tanggung Jawab Anda",
    description: `
      <p>
        Ketika kami meminta Anda untuk mengisi data pribadi, baik dalam bentuk data pribadi, Anda bertanggung jawab penuh atas setiap informasi yang Anda berikan kepada kami. Anda diharapkan untuk memberikan informasi yang benar.
      </p>

      <p>
        Anda bertanggung jawab penuh atas perilaku Anda saat menggunakan Situs Web. Anda diharapkan: 
      </p>

      <ol>
        <li>
          Jaga kerahasiaan password yang Anda buat.
        </li>

        <li>
          Batasi akses ke komputer atau perangkat seluler Anda.
        </li>

        <li>
          Setuju untuk menerima tanggung jawab penuh atas semua aktivitas yang terjadi pada Akun Anda.
        </li>

        <li>
          Anda harus memberikan konfirmasi kepada kami jika ada pelanggaran keamanan atau penyalahgunaan akun Anda.
        </li>

        <li>
          Mematuhi semua aturan, kebijakan, pedoman, instruksi, dan prosedur kami yang dapat berubah dari waktu ke waktu, serta kode etik (jika ada) dan seluruh Hukum Republik Indonesia yang berlaku.
        </li>

        <li>
          Mematuhi ketentuan anti‑korupsi dan anti‑pencucian uang serta peraturan terkait saat berinteraksi dengan pejabat, perwakilan pemerintah, atau entitas terkait pemerintah.
        </li>

        <li>
          Bertindak dengan itikad baik dan memberikan informasi yang benar serta akurat kepada pelanggan atau calon pelanggan.
        </li>

        <li>
          Memperoleh persetujuan yang diperlukan untuk pengungkapan data pelanggan, memastikan kebenaran data tersebut, dan bertanggung jawab atas kesalahan data yang berasal dari pelanggan atau calon pelanggan.
        </li>

        <li>
          Menjamin keaslian data untuk permohonan penutupan dan klaim asuransi; Anda bertanggung jawab atas data yang tidak benar atau tidak otentik.
        </li>

        <li>
          Menanggung semua biaya yang timbul dalam pelaksanaan tugas, kewajiban, dan tanggung jawab Anda.
        </li>

        <li>
          Melaksanakan dan menyelesaikan seluruh tugas, kewajiban, dan fungsi yang Anda miliki berdasarkan Layanan yang diberikan sesuai dengan Syarat dan Ketentuan serta peraturan yang berlaku.
        </li>
      </ol>
    `,
  },
  {
    title: "Rekaman",
    description: `
      <p>
        Untuk tujuan pengembangan produk, pelatihan, dan perlindungan korupsi, percakapan Anda (termasuk telepon, panggilan video, obrolan Whatsapp, atau bentuk komunikasi lainnya) dengan kami atau email Anda yang dikirimkan kepada kami dapat direkam. Kami menganggap bahwa Anda memberi kami persetujuan untuk menggunakan rekaman tersebut. 
      </p>
    `,
  },
  {
    title: "Hak Kekayaan Intelektual",
    description: `
      <p>
        Kecuali ditentukan secara khusus, Situs Web Kami beserta seluruh elemen yang terkandung di dalamnya termasuk namun tidak terbatas pada kode sumber, basis data, fungsionalitas sistem, perangkat lunak, desain antarmuka, konten audio dan visual, teks, foto, grafis, serta materi lain yang serupa yang dapat memperoleh perlindungan hak cipta (termasuk karya-karya turunannya) (seluruhnya disebut sebagai "Konten") — maupun merek dagang, merek jasa, dan logo yang terdapat pada Platform ("Merek"), merupakan milik, dan berada di bawah kendali, atau telah dilisensikan kepada Kami, serta dilindungi oleh ketentuan perundang-undangan di bidang hak cipta, merek dagang, dan hak kekayaan intelektual lainnya yang berlaku. Tanpa persetujuan tertulis terlebih dahulu dari Kami, Konten maupun Merek dilarang keras untuk disalin, direproduksi, dihimpun, diterbitkan kembali, diunggah, disebarluaskan, ditampilkan secara publik, dialihkodekan, diterjemahkan, dikirimkan, didistribusikan, diperjualbelikan, dilisensikan, ataupun dimanfaatkan untuk kepentingan komersial dalam bentuk apa pun, baik secara keseluruhan maupun sebagian. 
      </p>
    `,
  },
  {
    title: "Keadaan Kahar",
    description: `
      <p>
        Lifepal tidak bertanggung jawab kepada Anda berdasarkan Syarat dan Ketentuan ini jika dicegah atau ditunda dalam melakukan kewajibannya berdasarkan Syarat dan Ketentuan ini, atau dari menjalankan bisnisnya, dengan tindakan, peristiwa, kelalaian atau kecelakaan di luar kendali yang wajar, termasuk, tanpa batasan, pemogokan, lock-out atau perselisihan industri lainnya (baik yang melibatkan tenaga kerja Lifepal atau pihak lain), kegagalan layanan utilitas atau jaringan transportasi atau telekomunikasi, tindakan Tuhan, perang, kerusuhan, huru-hara, kerusakan berbahaya, kepatuhan terhadap hukum atau perintah pemerintah, aturan, peraturan atau arahan, kecelakaan, kerusakan pabrik atau mesin, kebakaran, banjir, badai atau default pemasok atau sub-kontraktor, asalkan Anda diberitahu tentang peristiwa tersebut dan durasi yang diharapkan. 
      </p>
    `,
  },
  {
    title: "Batasan Tanggung Jawab",
    description: `
      <ol>
        <li>
          Sejauh diizinkan oleh hukum yang berlaku, kami mengambil langkah-langkah yang wajar dan perlu untuk memastikan bahwa Situs Web kami aman dan tersedia. Kami melakukan ini untuk memberi Anda pengalaman terbaik. Namun, kami tidak membuat pernyataan atau jaminan apa pun, dalam keadaan apa pun, baik secara eksplisit maupun implisit, bahwa Situs Web kami aman atau tersedia setiap saat.
        </li>
        <li>
          Dalam hal apa pun, kami tidak bertanggung jawab atas kerugian dan/atau kerusakan langsung, konsekuensial, atau hukuman, atau kerugian laba yang timbul dari penggunaan Situs Web. Dalam keadaan apa pun, tanggung jawab kami, termasuk kelalaian, tidak akan melebihi jumlah uang yang dibayarkan oleh Anda sebagai akibat dari kerugian dan / atau kerusakan yang timbul dari penggunaan Situs Web kami (jika ada). 
        </li>

        <li>
          Materi apa pun yang diunduh atau diperoleh melalui penggunaan layanan ini adalah risiko Anda sendiri. Anda secara sukarela menanggung risiko ini, dan Anda akan bertanggung jawab penuh atas kehilangan atau kerusakan yang timbul dari atau terkait dengan materi tersebut, termasuk kerusakan pada sistem komputer Anda atau kehilangan data yang diakibatkan oleh pengunduhan materi yang disediakan. 
        </li>

        <li>
          Anda setuju untuk melepaskan dan memberhentikan Lifepal, afiliasinya, dan semua direktur, pejabat, karyawan, agen, mitra, penerusnya, dari klaim, tuntutan, biaya, kerusakan, tindakan, kerugian, kewajiban, penalti, termasuk biaya pengacara yang wajar, yang timbul dari atau terkait dengan informasi, konten, komentar, atau pendapat apa pun yang Anda kirimkan, sajikan, atau kirimkan ke Lifepal, penggunaan Anda atas layanan kami, pelanggaran Anda terhadap Syarat &amp; Ketentuan ini, atau pelanggaran Anda terhadap hak, kepemilikan, atau kepentingan pihak ketiga mana pun sebagai akibat dari penggunaan dan akses Anda ke Layanan kami. 
        </li>

        <li>
          Dengan menggunakan layanan kami, Anda memahami bahwa Layanan kami tidak bebas dari virus, worm, trojan horse, atau kode apa pun yang mungkin memiliki sifat mencemari atau merusak. Anda diharapkan dan bertanggung jawab untuk menerapkan prosedur dan tindakan pencegahan yang memadai (i) saat memberikan informasi/data dalam mengajukan perlindungan asuransi dan/atau menggunakan layanan kami, dan (ii) memelihara sistem Anda untuk merekonstruksi data yang hilang pada perangkat digital yang Anda gunakan. Setiap transmisi informasi oleh Anda kepada kami adalah risiko Anda sendiri. Terlepas dari efektivitas teknologi apa pun, Anda memahami bahwa tidak ada sistem keamanan yang tidak dapat ditembus atau aman dari bug, virus, akses yang tidak sah atau melanggar hukum. 
        </li>
      </ol>
    `,
  },
  {
    title: "Ganti Rugi dan Pengecualian",
    description: `
      <p>
        Anda setuju untuk mengganti kerugian kepada kami atau pihak ketiga atas kerugian atau kerusakan baik secara langsung maupun tidak langsung yang timbul dari pelanggaran Anda terhadap Syarat dan Ketentuan, Kebijakan Privasi, syarat dan ketentuan lain dan persyaratan pada halaman web lain dari Situs Web Kami.
      </p>
    `,
  },
  {
    title: "Lain-Lain",
    description: `
      <ol>
        <li>
          Syarat dan Ketentuan ini akan menggantikan dan menggantikan semua perjanjian dan pemahaman sebelumnya, lisan atau tertulis.
        </li>
        <li>
          Kecuali sebagaimana ditentukan di sini, kegagalan untuk menggunakan hak atau meminta pelaksanaan kewajiban berdasarkan Syarat dan Ketentuan ini tidak akan mempengaruhi kemampuan salah satu pihak untuk menggunakan hak tersebut atau memerlukan kinerja tersebut setiap saat sesudahnya dan pengabaian pelanggaran merupakan pengabaian pelanggaran berikutnya. 
        </li>
        <li>
          Jika Anda menggunakan Situs Web untuk atau atas nama pihak ketiga, seperti anggota keluarga atau teman atau wali, pihak ketiga tersebut dianggap telah menyetujui dan terikat oleh semua ketentuan yang terkandung dalam Syarat dan Ketentuan ini. Anda bertanggung jawab atas ketidakakuratan dalam informasi yang diberikan sehubungan dengan penggunaan tersebut. 
        </li>

        <li>
          Anda tidak boleh mengalihkan atau mengalihkan hak atau kewajiban Anda berdasarkan Syarat dan Ketentuan ini tanpa persetujuan tertulis sebelumnya dari kami. 
        </li>

        <li>
          Kami dapat menetapkan, mensublisensikan, atau mentransfer hak apa pun yang diberikan kepada Lifepal atau mensubkontrakkan kewajiban Lifepal dalam menyediakan layanan di Situs Web. 
        </li>

        <li>
          Syarat &amp; Ketentuan ini dibuat dalam Bahasa Indonesia dan dapat diterjemahkan ke Bahasa Inggris atau bahasa lainnya sesuai dengan kebutuhan Kami. Dalam hal terjadi ketidakkonsistenan atau pertentangan antara kedua versi bahasa tersebut, Anda setuju bahwa versi bahasa Indonesia yang akan berlaku, dan versi bahasa Inggris atau versi bahasa lainnya akan dianggap diubah dan ditafsirkan agar sesuai dengan dan konsisten dengan versi bahasa Indonesia yang relevan dari Syarat &amp; Ketentuan ini. 
        </li>

        <li>
          Kami akan menggunakan upaya terbaik untuk memastikan keamanan digital Situs Web Kami namun kami tidak dapat menjamin keamanan tersebut akan sempurna khususnya kami tidak  akan bertanggung jawab atas masalah yang terjadi akibat pengaksesan ilegal, tanpa ijin dan tidak sesuai dengan standa dan ketentuan kami serta dari informasi yang Anda sediakan. Kami harap kerja sama Anda untuk menjaga kerahasiaan kata sandi (password) yang Anda gunakan untuk mengakses Situs Web Kami dan pemanfaatan Layanan Kami. 
        </li>

        <li>
          Anda mengakui dan setuju bahwa seluruh informasi yang disediakan pada Situs Web Kami disediakan apa adanya. 
        </li>
      </ol>
    `,
  },
  {
    title: "Hukum yang Mengatur dan Keberlakuan",
    description: `
      <p>
        Syarat dan Ketentuan Situs Web Kami diatur oleh hukum Republik Indonesia. Jika ada perselisihan, maka akan diajukan ke Pengadilan Negeri Jakarta Selatan.
      </p>

      <p>
        Jika salah satu Syarat dan Ketentuan ilegal, batal, atau tidak dapat dilaksanakan, karena alasan apa pun, akan dianggap bahwa Syarat dan Ketentuan yang disebutkan di atas tidak pernah ada. Ini tidak akan mempengaruhi validitas dan keberlakuan Syarat dan Ketentuan lainnya.
      </p>
    `,
  },
  {
    title: "Keterpisahan",
    description: `
      <p>
        Jika salah satu dari Syarat dan Ketentuan ini atau bagian manapun dari syarat dan ketentuan ini menjadi ilegal, tidak sah, atau tidak dapat dilaksanakan berdasarkan hukum yurisdiksi manpun di mana kebijakan privasi ini dimaksudkan untuk berlaku, maka di yurisdiksi tersebut akan dianggap dipisahkan dan dihapus dari Ketentuan ini dan Ketentuan lainnya akan bertahan dan tetap mempunyai kekuatan dan efek penuh serta terus mengikat dan dapat dilaksanakan dalam yurisdiksi tersebut.
      </p>
    `,
  },
  {
    title: "Kontak",
    description: `
      <p>
        Jika Anda memiliki pertanyaan, rekomendasi, keluhan, atau komentar sehubungan dengan syarat dan ketentuan atau persyaratan apa pun di Situs Web Kami, silakan hubungi kami di Email: support@lifepal.co.id atau telefon: 021 3076 2309.
      </p>
    `,
  },
];
